import React from 'react'
import WidgetProvider from './WidgetContext'
import UtilsProvider from './UtilsContext'
import LocaleProvider from './LocaleContext'
import AdaptiveCardProvider from './AdaptiveCardContext'
import ViewProvider from './ViewContext'
import SpeechProvider from './SpeechContext'
import RetorikProvider from './RetorikContext'
import ActivityProvider from './ActivityContext'
import DirectlineProvider from './DirectlineContext'
import InputOutputHandler from './InputOutputHandler'
import ExternalHooksHandler from './ExternalHooksHandler'

const GlobalProvider = ({ instanceId, children }): JSX.Element => {
  return (
    <WidgetProvider>
      <UtilsProvider>
        <LocaleProvider>
          <AdaptiveCardProvider>
            <SpeechProvider>
              <RetorikProvider>
                <ViewProvider>
                  <ActivityProvider>
                    <DirectlineProvider>
                      <InputOutputHandler instanceId={instanceId} />
                      <ExternalHooksHandler instanceId={instanceId} />
                      {children}
                    </DirectlineProvider>
                  </ActivityProvider>
                </ViewProvider>
              </RetorikProvider>
            </SpeechProvider>
          </AdaptiveCardProvider>
        </LocaleProvider>
      </UtilsProvider>
    </WidgetProvider>
  )
}

export default GlobalProvider
